/* eslint-disable import/default */

import "babel-polyfill"
import React from "react"
import { render } from "react-dom"
import { browserHistory } from "react-router"
import { AppContainer } from "react-hot-loader"
import Root from "./app/Root"

import configureStore from "./data/configureStore"
import { syncHistoryWithStore } from "react-router-redux"
// import ThemeWrapper from "styleguide/ThemeWrapper"

const store = configureStore()

// Create an enhanced history that syncs navigation events with the store
const history = syncHistoryWithStore(browserHistory, store)

function doRender() {
    render(
        <AppContainer>
            {/* <ThemeWrapper> */}
            <Root store={store} history={history} />
            {/* </ThemeWrapper> */}
        </AppContainer>,
        document.getElementById("app")
    )
}

doRender()

if (module.hot) {
    module.hot.accept("./app/Root", () => {
        doRender()
    })
}

export default history



// WEBPACK FOOTER //
// ./src/index.js